import { Sensor, SensorReading, SensorConfig } from '../types';
import { apiClient } from './api';

// Typ pro API response s data wrapperem
interface ApiDataResponse<T> {
  data: T;
  count?: number;
}

export const sensorService = {
  // Vrati vsechny senzory
  getAllSensors: async (): Promise<Sensor[]> => {
    const response = await apiClient.get<ApiDataResponse<Sensor[]>>('/sensors');
    return response.data;
  },

  // Vrati senzor podle ID
  getSensorById: async (id: string): Promise<Sensor> => {
    const response = await apiClient.get<ApiDataResponse<Sensor>>(`/sensors/${id}`);
    return response.data;
  },

  // Vrati posledni cteni senzoru
  getLatestReadings: async (): Promise<SensorReading[]> => {
    const response = await apiClient.get<ApiDataResponse<SensorReading[]>>(
      '/sensors/readings/latest',
    );
    return response.data;
  },

  // Aktualizuje konfiguraci senzoru
  updateSensorConfig: async (id: string, config: Partial<SensorConfig>): Promise<SensorConfig> => {
    // Transform frontend config structure to backend expected structure
    const payload: any = {
      name: config.name,
    };

    if (config.threshold) {
      payload.min_value = config.threshold.min;
      payload.max_value = config.threshold.max;
      // Also update thresholds if they are distinct in backend,
      // but for now map to min/max_value as that's what create uses.
      payload.threshold_min = config.threshold.min;
      payload.threshold_max = config.threshold.max;
    }

    const response = await apiClient.put<ApiDataResponse<SensorConfig>>(
      `/sensors/${id}`, // Endpoint for update is /sensors/:id
      payload,
    );
    return response.data;
  },

  // Vrati historicka data senzoru
  getSensorHistory: async (
    sensorId: string,
    startDate: string,
    endDate: string,
  ): Promise<SensorReading[]> => {
    const response = await apiClient.get<ApiDataResponse<SensorReading[]>>(
      `/sensors/${sensorId}/history`,
      {
        params: { startDate, endDate },
      },
    );
    return response.data;
  },

  // Zapne/vypne stream mod
  setStreamMode: async (
    deviceId: string,
    enabled: boolean,
    interval: number = 500,
  ): Promise<void> => {
    await apiClient.post('/sensors/stream', { deviceId, enabled, interval });
  },
};
